import React, { FC, useState, useContext } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';

import { BaseTournamentData, useTournamentArciveMutation, useTournamentMutation } from '../../api/tournament-data';
import { CentreHeading } from '../common-styles/common-styles';
import { SelectedIndexContext } from '../../App';
import { RYDER_CUP_TYPE, STABLEFORD_WITH_TEAM_GAMES } from '../../app/constants';

export const FlexColumnLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin: 0 0.25rem;
  align-items: flex-start;
`;
const PageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2rem 1rem;
  flex-direction: column;
`;
const InputWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem;
`;
const Button = styled.button`
  border-radius: 5px;
  width: 4rem;
  height: 1.5rem;
  background: lightblue;
  border: 1px solid #5c9db2;
  font-weight: 500;
  color: white;
  margin: 1rem 1rem;
  &:disabled {
    background-color: lightgray;
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const ErrorWrapper = styled.div`
  color: red;
`;
export const MatchEntryInput = styled.input`
  margin: 0 0.5rem;
`;
export const MatchEntryLabel = styled.label`
  margin-right: 0.5rem;
`;

export const ArchiveTournament: FC = () => {
  const { selectedTournamentIndex } = useContext(SelectedIndexContext);
  const navigate = useNavigate();
  const mutation = useTournamentArciveMutation();

  const archiveTournament = () => {
    mutation.mutate(selectedTournamentIndex, {
      onSuccess: (data) => {
        navigate('/');
      },
      onError: (error) => {
        console.log('<><><>ERROR<><><><', error);
      },
    });
    navigate(`/`);
  };

  return (
    <PageWrapper>
      <CentreHeading>
        <h2>Archive Tournament</h2>
      </CentreHeading>
      <FlexColumnLeft>
        <ButtonWrapper>
          <Button data-testid="submit-button" onClick={() => archiveTournament()}>
            Submit
          </Button>
        </ButtonWrapper>
      </FlexColumnLeft>
    </PageWrapper>
  );
};
